import "./LocalAdmins.scss";

import GenericTable from "../../components/Table/GenericTable";
import React from "react";

const tableStructure = [
  {
    header: "Imię",
    field: "first_name",
    accessor: "user__first_name",
    className: "w-2",
    sort: true
  },
  {
    header: "Nazwisko",
    field: "last_name",
    accessor: "user__last_name",
    className: "w-3",
    sort: true
  },
  {
    header: "Login",
    field: "username",
    accessor: "user__username",
    className: "w-3",
    sort: true
  },
  {
    header: "Biblioteka",
    field: "library.name",
    accessor: "library__name",
    className: "w-2",
    sort: true,
    url: "/library/<id>/preview/"
  },
  {
    header: "Akcje",
    className: "w-2 has-text-right"
  }
];

const urls = {
  get: "/api/users/admins/",
  add: "/users/admins/create/",
  edit: "/users/admins/", //appends /${id}/update
  delete: "/api/users/admins/" //appends /${id}/
};

const messages = {
  deleteSuccess: "Administrator lokalny został poprawnie usunięty",
  deleteError: "Wystąpił problem podczas usuwania Administratoralokalnego",
  btnAdd: "Dodaj administratora",
  btnDeleteNo: "Anuluj",
  btnDeleteYes: "Usuń",
  headerTitle: "Potwierdzenie usunięcia",
  bodyContent: "Czy na pewno chcesz usunąć Administratora lokalnego?",
  contentLabel: "Potwierdzenie usunięcia Administratora lokalnego"
};

const LocalAdmins = ({ message, hasCreatePermission }) => {
  return (
    <section className="local-admins">
      <div className={"container"}>
        <div className="breadcrumbs">
          <a
            href="/admin-panel/home/"
            className="breadcrumbs__link"
            title="Strona główna"
          >
            Strona główna
          </a>
          &nbsp;/&nbsp;
          <strong>Administratorzy lokalni</strong>
        </div>
        <GenericTable
          structure={tableStructure}
          notification={message}
          messages={messages}
          urls={urls}
          deleteItemName="username"
          disablePreview={false}
          hasHeaderActions={hasCreatePermission}
        />
      </div>
    </section>
  );
};

export default LocalAdmins;
